'use strict';

exports.__esModule = true;

var _kindergarten = require('kindergarten');

exports.default = function () {
  var perimeters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!Array.isArray(perimeters)) {
    throw new _kindergarten.ArgumentError('Array of perimeters must be given.');
  }

  perimeters.forEach(function (perimeter) {
    if (!(0, _kindergarten.isPerimeter)(perimeter)) {
      throw new _kindergarten.ArgumentError('Perimeters must be instance of perimeter.');
    }
  });

  return perimeters;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-kindergarten/lib/vue-kindergarten/getPerimeters.js
// module id = dMLd
// module chunks = 0